import getSuitabilityState from '../../../queries/getSuitabilityState'

const STORED_QUESTION_TYPENAME = 'StoredQuestion'
const CORE_SUITABILITY_QUESTION_TYPENAME = 'suitability_SuitabilityQuestion'

// Asserts that a typename exists all all items in the collection
export function assertTypename(items: any[], type: string) {
  items.forEach(item => {
    if (!Object.keys(item).includes('__typename')) {
      // No typename exists, so apply the typename
      item.__typename = type
    } else {
      // If a typename exists, assert
      if (item.__typename !== type) {
        throw Error('Invalid typename')
      }
    }
  })
}

export default function(root, { input }, { cache }) {
  const {
    coreSuitabilityQuestions,
    page,
    recommendation,
    showCoreSuitabilityQuestions,
    showNextButton,
    storedQuestions,
  } = input

  // Validate typename on inputs
  if (storedQuestions) {
    assertTypename(storedQuestions, STORED_QUESTION_TYPENAME)
  }

  if (coreSuitabilityQuestions) {
    assertTypename(coreSuitabilityQuestions, CORE_SUITABILITY_QUESTION_TYPENAME)
  }

  const localState = cache.readQuery({ query: getSuitabilityState })
  const data = {
    coreSuitabilityQuestions: coreSuitabilityQuestions || localState.coreSuitabilityQuestions,
    page: page || localState.page,
    recommendation: recommendation || localState.recommendation,
    showCoreSuitabilityQuestions:
      showCoreSuitabilityQuestions || localState.showCoreSuitabilityQuestions,
    showNextButton: showNextButton || localState.showNextButton,
    storedQuestions: storedQuestions || localState.storedQuestions || storedQuestions,
    __typename: 'LaterSuitabilityState',
  }

  // In this POC, we are just going to write over existing data, and then return
  // all of local state
  cache.writeData({
    data,
  })

  return data
}
